import EcCommon from '../../types/ec/ecCommon';
import EcMemberSearch from '../../types/ec/ecMemberSearch';
import LtFramework from '../../types/lt/ltFramework';

export const AlertNotificationConstant: LtFramework.IAlertNotificationConstant = {
	alertNotificationId: 'alert-notification',
	alertNotificationPrefix: 'alert-notification-',
	alertNotificationSuccess: 'alert-success',
	alertNotificationInfo: 'alert-info',
	alertNotificationWarning: 'alert-warning',
	alertNotificationDanger: 'alert-danger',
	alertNotificationElementId: '.js-alert-notification',
};

export const AlertNotificationModuleConstant: LtFramework.IAlertNotificationModuleConstant = {
	action: {
		synchronize: 'synchronize',
		open: 'open',
		close: 'close',
	},
	getter: {},
	mutation: {
		setAlertNotifications: 'setAlertNotifications',
	},
	name: 'alertNotificationModule',
	state: {
		alertNotifications: 'alertNotifications',
	},
};

export const CookieConstant: LtFramework.ICookieConstant = {
	profileToken: 'ltf-profile',
	ssoId: 'LTFSSOIDCookie',
};

export const EventConstant: EcCommon.IEventConstant = {
	ClubServiceLoading: 'club-service-loading',
	CoachServiceLoading: 'coach-service-loading',
	GetClientLists: 'get-client-lists',
	MemberSearchServiceLoading: 'member-search-service-loading',
	PersonServiceLoading: 'person-service-loading',
	PlanServiceLoading: 'plan-service-loading',
	programChange: 'program-change',
	WorkoutServiceLoading: 'workout-service-loading',
};

export const FreeProgramConstant: EcCommon.IFreeProgramConstant = {
	ApplicationId: '61684052-49DA-4E94-A730-AF7AF29C3BFD',
	RoleId: 'D92B935A-99A5-4841-9A21-77C334ADB114',
};

export const ClubLocationsModuleConstant: EcCommon.IClubLocationsModuleConstant = {
	action: {
		getClubLocations: 'getClubLocations',
		selectClub: 'selectClub',
		unSelectClub: 'unSelectClub',
		unSelectAllClubs: 'unSelectAllClubs',
	},
	getter: {
		getClubs: 'getClubs',
		getClubObjects: 'getClubObjects',
	},
	mutation: {
		setCountries: 'setCountries',
		setClub: 'setClub',
		removeClub: 'removeClub',
		unSelectAllClubs: 'unSelectAllClubs',
	},
	name: 'clubLocationsModule',
	state: {
		countries: 'countries',
		selectedClubs: 'selectedClubs',
	},
};

export const EmployeeProfileModuleConstant: LtFramework.IEmployeeProfileModuleConstant = {
	action: {
		synchronize: 'synchronize',
	},
	getter: {
		getIsValid: 'getIsValid',
	},
	mutation: {
		setEmployeeProfile: 'setEmployeeProfile',
	},
	name: 'employeeProfileModule',
	state: {
		employeeProfile: 'employeeProfile',
	},
};

export const EmployeeStateConstant: LtFramework.IEmployeeStateConstant = {
	unknown: 'UNKNOWN',
	authenticated: 'AUTHENTICATED',
	unauthenticated: 'UNAUTHENTICATED',
};

export const MemberSearchModuleConstant: EcMemberSearch.IMemberSearchModuleConstant = {
	action: {
		clearMembers: 'clearMembers',
		searchMemberPhoto: 'searchMemberPhoto',
		setTrainerDetails: 'setTrainerDetails',
		searchMembers: 'searchMembers',
		searchConnectedStatus: 'searchConnectedStatus',
		setEmailAddressInvalid: 'setEmailAddressInvalid',
		updateConnectedStatus: 'UpdateConnectedStatus',
	},
	getter: {},
	mutation: {
		setTrainerDetails: 'setTrainerDetails',
		setMembers: 'setMembers',
		resetMembers: 'resetMembers',
		setMemberPhoto: 'setMemberPhoto',
		setConnectStatus: 'setConnectStatus',
		setEmailAddressInvalid: 'setEmailAddressInvalid',
		updateConnectionStatus: 'updateConnectionStatus',
	},
	name: 'memberSearchModule',
	state: {
		members: 'members',
	},
};

export const MemberStateConstant: LtFramework.IMemberStateConstant = {
	unknown: 'UNKNOWN',
	authenticated: 'AUTHENTICATED',
	unauthenticated: 'UNAUTHENTICATED',
	remembered: 'REMEMBERED',
};

export const ProfileModuleConstant: LtFramework.IProfileModuleConstant = {
	action: {
		synchronize: 'synchronize',
	},
	getter: {
		getIsValid: 'getIsValid',
	},
	mutation: {
		setProfile: 'setProfile',
	},
	name: 'profileModule',
	state: {
		profile: 'profile',
	},
};

export const ProgramAlertConstant: EcCommon.IProgramAlertConstant = {
	programError: 'programError',
	programNotFound: 'programNotFound',
	newProgramEnrollment: 'newProgramEnrollment',
	InvalidTrainerizeProgram: 'InvalidTrainerizeProgram',
	LifeTimeTrainingApp: 'lifeTimeTrainingApp',
};

export const RegularExpressionConstant: EcCommon.IRegularExpressionConstant = {
	authorRegex: /author\.lifetimefitness\.com/,
};

export const PageDriverConstant: LtFramework.IPageDriverConstant = {
	freeProgram: 'freeProgram',
	loginResource: 'loginResource',
	home: 'home',
};

export const SectionConstant: LtFramework.ISectionConstant = {
	coaching: 'coaching',
	global: 'global',
};

export const StorageConstant: EcCommon.IStorageConstant = {
	dismissedTaskList: 'enterprise-coach-components-pt-task-list-dismissed-task-list',
};

export const UrlModuleConstant: LtFramework.IUrlModuleConstant = {
	action: {
		synchronize: 'synchronize',
	},
	mutation: {
		setUrl: 'setUrl',
	},
	getter: {
		getGlobalPageDriverUrl: 'getGlobalPageDriverUrl',
	},
	name: 'urlModule',
	state: {
		url: 'url',
	},
};
